import { Leaf, Drop, Sun, Tree, HandHeart, Recycle } from "@phosphor-icons/react";

const INITIATIVES = [
  { icon: Tree, title: "Forest Memory Atlas", text: "Mapping ancestral forest knowledge with open scientific protocols." },
  { icon: Drop, title: "Decentralized Water", text: "Community-run desalination and water-cycle restoration labs." },
  { icon: Sun, title: "Quiet Energy", text: "Low-noise renewable systems designed for villages and forests." },
  { icon: HandHeart, title: "Healing Soils", text: "Mycelial and microbial regeneration of degraded agricultural land." },
  { icon: Leaf, title: "Biophilic Cities", text: "Urban design where buildings host rather than displace ecosystems." },
  { icon: Recycle, title: "Circular Materials", text: "Material flows modeled on natural metabolic cycles." },
];

export default function EarthInnovation() {
  return (
    <div data-testid="page-earth">
      <section className="relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1593069567131-53a0614dde1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxuYXR1cmUlMjBlY29sb2d5JTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODIwOTQ3NjR8MA&ixlib=rb-4.1.0&q=85)" }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-ink/55" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-32 lg:py-44 text-white">
          <p className="overline text-gold">Earth Innovation Center</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight max-w-4xl">
            The Earth is the first invention. We are still learning to read it.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-white/80 leading-relaxed">
            A laboratory and a living school for ecological intelligence — where
            healing technologies, ancestral wisdom, and rigorous science meet.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 lg:py-32 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="overline">Our principle</p>
            <h2 className="mt-3 font-display text-4xl lg:text-5xl font-light tracking-tight text-ink leading-[1.1]">
              Innovation that serves the living.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-lg leading-relaxed text-ink/70 space-y-5">
            <p>
              We believe that ecology is not a constraint on innovation. It is
              the original blueprint we are still learning to read. The Earth
              Innovation Center exists to translate that blueprint into open,
              replicable practice.
            </p>
            <p>
              Our work spans soils, water, energy, materials and urban form. In
              each, we partner with communities and elders so that knowledge
              flows in both directions.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24" data-testid="earth-initiatives">
        <p className="overline">Initiatives</p>
        <h2 className="mt-3 font-display text-3xl lg:text-5xl font-light tracking-tight text-ink">
          Six fields of practice.
        </h2>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {INITIATIVES.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.title} className="bg-white rounded-2xl ring-1 ring-ink/10 p-7 card-shadow hover:-translate-y-1 transition-transform" data-testid={`initiative-${p.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-earth/15 text-earth">
                  <Icon size={22} weight="duotone" />
                </div>
                <h3 className="mt-5 font-display text-xl text-ink">{p.title}</h3>
                <p className="mt-2 text-ink/65 leading-relaxed text-base">{p.text}</p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
